module.exports = __webpack_public_path__ + "static/media/defaultCreative.09b77349.jpg";